import script from "./section6-parallax.vue?vue&type=script&setup=true&lang=js"
export * from "./section6-parallax.vue?vue&type=script&setup=true&lang=js"

import "./section6-parallax.vue?vue&type=style&index=0&id=44bc30ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bc30ca"]])

export default __exports__